import { Icon } from "@iconify/react";

import CodeIcon from "@mui/icons-material/Code";
// import JavascriptIcon from "@mui/icons-material/Javascript";
// import HtmlIcon from "@mui/icons-material/Html";
// import PhpIcon from "@mui/icons-material/Php";
// import CssIcon from "@mui/icons-material/Css";
// import AccountTreeIcon from "@mui/icons-material/AccountTree";
// import TerminalIcon from "@mui/icons-material/Terminal";
// import DatasetIcon from "@mui/icons-material/Dataset";
// import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
// import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
// import LiveTvIcon from "@mui/icons-material/LiveTv";
// import SchoolIcon from "@mui/icons-material/School";
// import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
// import CheckroomIcon from "@mui/icons-material/Checkroom";
// import GraphicEqIcon from "@mui/icons-material/GraphicEq";
// import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
// import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
// import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
// import OnDeviceTrainingIcon from "@mui/icons-material/OnDeviceTraining";

export const logo = "https://i.ibb.co/s9Qys2j/logo.png";

export const categories = [
  {
    name: "New Technology",
    icon: <Icon icon="healthicons:t-negative" fontSize={25} />
  },
  {
    name: "Hackhthon",
    icon: <Icon icon="ph:text-h-fill" fontSize={25} />
  },
  { name: "Python", icon: <Icon icon="logos:python" fontSize={25} /> },
  {
    name: "JavaScript",
    icon: <Icon icon="skill-icons:javascript" fontSize={25} />
  },
  {
    name: "TypeScript ",
    icon: <Icon icon="skill-icons:typescript" fontSize={25} />
  },
  {
    name: "CoffeeScript ",
    icon: <Icon icon="skill-icons:coffeescript-dark" fontSize={25} />
  },
  {
    name: "ReactJS",
    icon: <Icon icon="skill-icons:react-dark" fontSize={25} />
  },
  {
    name: "NextJS",
    icon: <Icon icon="skill-icons:nextjs-dark" fontSize={25} />
  },
  { name: "Java", icon: <Icon icon="skill-icons:java-dark" fontSize={25} /> },
  {
    name: "NodeJS",
    icon: <Icon icon="skill-icons:nodejs-dark" fontSize={25} />
  },

  { name: "MongoDB", icon: <Icon icon="skill-icons:mongodb" fontSize={25} /> },
  {
    name: "HTML",
    icon: <Icon icon="vscode-icons:file-type-html" fontSize={25} />
  },
  { name: "CSS", icon: <Icon icon="skill-icons:css" fontSize={25} /> },
  { name: "PHP", icon: <Icon icon="devicon:php" fontSize={25} /> },
  { name: "C ", icon: <Icon icon="devicon:c" fontSize={25} /> },
  { name: "C++ ", icon: <Icon icon="file-icons:c" fontSize={25} /> },
  { name: "C# ", icon: <Icon icon="logos:c-sharp" fontSize={25} /> },
  { name: "DBMS ", icon: <Icon icon="bxs:data" fontSize={25} /> },
  {
    name: "Kotlin ",
    icon: <Icon icon="skill-icons:kotlin-dark" fontSize={25} />
  },
  { name: "Ruby Code", icon: <Icon icon="skill-icons:ruby" fontSize={25} /> },
  {
    name: "MATLAB ",
    icon: <Icon icon="skill-icons:matlab-dark" fontSize={25} />
  },
  { name: "SQL ", icon: <Icon icon="skill-icons:mysql-dark" fontSize={25} /> },
  {
    name: "Scala ",
    icon: <Icon icon="skill-icons:scala-dark" fontSize={25} />
  },
  {
    name: "Data Structure",
    icon: <Icon icon="carbon:data-structured" fontSize={25} />
  },
  { name: "Bash", icon: <Icon icon="skill-icons:bash-dark" fontSize={25} /> },
  { name: "Linux", icon: <Icon icon="devicon:linux" fontSize={25} /> },
  { name: "Unix", icon: <Icon icon="skill-icons:linux-dark" fontSize={25} /> },
  { name: "IOT ", icon: <Icon icon="fluent:iot-24-filled" fontSize={25} /> },
  {
    name: "Powershell ",
    icon: <Icon icon="skill-icons:powershell-dark" fontSize={25} />
  },
  {
    name: "COBOL ",
    icon: <Icon icon="vscode-icons:file-type-cobol" fontSize={25} />
  },
  { name: "Fortran ", icon: <Icon icon="skill-icons:fortran" fontSize={25} /> },
  {
    name: "Scratch Code ",
    icon: <Icon icon="simple-icons:scratch" fontSize={25} />
  },
  { name: "Perl", icon: <Icon icon="skill-icons:perl" fontSize={25} /> },
  {
    name: "Visual Basic",
    icon: <Icon icon="skill-icons:visualstudio-dark" fontSize={25} />
  },
  {
    name: "HackarRank",
    icon: <Icon icon="simple-icons:hackerrank" fontSize={25} />
  },
  {
    name: "Lisp",
    icon: <Icon icon="file-icons:common-lisp" fontSize={25} />
  },
  {
    name: "Rust Code",
    icon: <Icon icon="simple-icons:rust" fontSize={25} />
  },
  {
    name: "Swift",
    icon: <Icon icon="skill-icons:swift" fontSize={25} />
  },
  {
    name: "Lua",
    icon: <Icon icon="logos:lua" fontSize={25} />
  },
  {
    name: "Dart Code",
    icon: <Icon icon="logos:dart" fontSize={25} />
  },
  {
    name: "Haskell",
    icon: <Icon icon="logos:haskell-icon" fontSize={25} />
  },
  {
    name: "Ada Code",
    icon: <Icon icon="vscode-icons:file-type-ada" fontSize={25} />
  },
  {
    name: "Julia Code",
    icon: <Icon icon="devicon-plain:julia-wordmark" fontSize={25} />
  }
];

export const demoThumbnailUrl = "https://i.ibb.co/G2L2Gwp/API-Course.png";
export const demoChannelUrl = "/channel/UCmXmlB4-HJytD7wek0Uo97A";
export const demoVideoUrl = "/video/GDa8kZLNhJ4";
export const demoChannelTitle = "Alphabet Technology";
export const demoVideoTitle =
  "Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI";
export const demoProfilePicture =
  "http://dergipark.org.tr/assets/app/images/buddy_sample.png";
